import React, { useEffect } from "react";
import { BlogPostInfo, GenerateRandomPosts, GetPostInfoArrayFromResponse, GetPublicBlogPosts } from "../Utilities/BlogAPI";
import { BlogPostSearchResult } from "./RenderBlogList";
import { UserContext } from "../Definitions/UserContext";
import GenericTrackedDropdown from "../GenericTrackedDropdown";

export default function RenderBlogSearch({userContext}:{userContext:UserContext}) {


    const [isFocused,setIsFocused] = React.useState(false);

    const [blogPosts, setBlogPosts] = React.useState<BlogPostInfo[]>([]);
    const [searchText,setSearchText] = React.useState("");
    const containerRef = React.useRef<HTMLDivElement>(null);
    const [isLoading,setIsLoading] = React.useState(true);
    const inputRef = React.useRef<HTMLInputElement>(null);
    useEffect(()=>{

        GetPublicBlogPosts(userContext,(data)=>{
            setIsLoading(false);
           setBlogPosts( GetPostInfoArrayFromResponse(data));
        },(data)=>{})

        

    },[])

    const clickOutside = (e:any)=>{
        if(containerRef.current&&!containerRef.current.contains(e.target)&& e.target.tagName!= "INPUT"){
            setIsFocused(false);
        }


    }

    useEffect(()=>{

        document.addEventListener("click",clickOutside);
        return ()=>{
            document.removeEventListener("click",clickOutside);
        }

    },[containerRef])

    return (
        <div className={"blog-search w-full relative "}      ref = {containerRef} >
            <svg style={{position:"absolute",left:"10px",top:"14px",opacity:".8"}} fill="currentColor" height="1em" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg>
            <input
            ref = {inputRef}
            onInput={(e)=>setSearchText((e.target as any).value)}
            onFocus={()=>setIsFocused(true)}

            
            style={{ padding:"10px 20px 10px 36px",border:"1px solid var(--theme-color-4)",borderRadius:"4px",minWidth:"240px"}} 
            className="w-full no-events-in-canvas" type="text" placeholder="Search all blog posts" />
          {
                isFocused&&containerRef.current&&searchText.length>2&&<ResultDropdownTracked containerRef={containerRef} isLoading={isLoading} posts={blogPosts} filter={searchText}/>

          }
       {searchText.length>0&& <SearchXIcon right={"2px"} top={"25%"} height="45%" onClick={()=>{
            setSearchText("");
            inputRef.current!.value = "";
        }} />
    }

        </div>
    )
}

function ResultDropdownTracked({posts,filter,isLoading,containerRef}:{containerRef:any,isLoading:boolean,filter:string,posts:BlogPostInfo[]}){

    let filteredPosts = posts.filter(post=>{

        let combinedString = (post.title +" "+ post.author +" "+ post.category.join(",") +" "+ post.tags.join(" ")+" "+(post.publishDateStr??"")).toLowerCase();
        let filterList = filter.toLowerCase().split(" ");
        for(let i = 0; i<filterList.length;i++){
            if(!combinedString.includes(filterList[i])){
                return false;
            }
        }
        return true;
    
       });

    return <GenericTrackedDropdown  domTarget={containerRef.current}  >
        <div className="w-full" style={{background:"#f7f7f7"}}>
                {isLoading&&<div style={{padding:"8px",opacity:".8"}}>Loading...</div>}
            {!isLoading&& filteredPosts.length==0&&<div style={{padding:"8px",opacity:".8"}}>No Results Found</div>}
            {filteredPosts.map((post,index)=><BlogPostSearchResult key={index} post={post} fullWidth={true}/>)}
            
            </div>
        </GenericTrackedDropdown>

}
function ResultDropDown({posts,filter,isLoading,containerRef}:{containerRef:any,isLoading:boolean,filter:string,posts:BlogPostInfo[]}){

    
    

    const [xPos,setXPos] = React.useState(containerRef.current.getBoundingClientRect().left);
    const [yPos,setYPos] = React.useState(containerRef.current.getBoundingClientRect().bottom);
    const [width,setWidth] = React.useState(containerRef.current.getBoundingClientRect().width);

   let filteredPosts = posts.filter(post=>{

    let combinedString = (post.title +" "+ post.author +" "+ post.category.join(",") +" "+ post.tags.join(" ")+" "+(post.publishDateStr??"")).toLowerCase();
    let filterList = filter.toLowerCase().split(" ");
    for(let i = 0; i<filterList.length;i++){
        if(!combinedString.includes(filterList[i])){
            return false;
        }
    }
    return true;

   });

   const updatePosition = ()=>{
        let bounds = containerRef.current.getBoundingClientRect();
        setXPos(bounds.left);
        setYPos(bounds.bottom);
        setWidth(bounds.width);

   }

   useEffect(()=>{

   
    let observer = new MutationObserver((mutationsList, observer) => {
        updatePosition();
    });

    observer.observe(containerRef.current, { attributes: true, childList: true, subtree: true });

    window.addEventListener("resize",updatePosition);
    document.addEventListener("scroll",updatePosition);
    return ()=>{
        document.removeEventListener("resize",updatePosition);
        window.removeEventListener("scroll",updatePosition);
    };



   },[])




    return <div className="w-full search-drop-down" style={{
        boxShadow:"0 6px 8px 8px #00000030",
        position:"fixed",zIndex:"2",left:xPos+"px",top:yPos+"px",width:width+"px",background:"#f7f7f7",borderRadius:"4px",maxHeight:"340px",overflow:"auto"}}>
        
        {isLoading&&<div style={{padding:"8px",opacity:".8"}}>Loading...</div>}
        {!isLoading&& filteredPosts.length==0&&<div style={{padding:"8px",opacity:".8"}}>No Results Found</div>}
        {filteredPosts.map((post,index)=><BlogPostSearchResult key={index} post={post} fullWidth={true}/>)}
    </div>


}


export function SearchXIcon({right,top,height,onClick}:{right:string,top:string,height:string,onClick?:()=>void}){

    return <button onClick={onClick} className="invisible-button" style={{cursor:"pointer",opacity:".4",position:"absolute",right:right,top:top,height:height}}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height={"100%"}  viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"/></svg>
    </button>
}